import React from "react";
import "../../styles/Home.css";
import { Link } from "react-router-dom";
import one from "../../assets/services/1.png";
import two from "../../assets/services/2.png";
import three from "../../assets/services/3.png";
import four from "../../assets/services/4.png";
import five from "../../assets/services/5.png";
import six from "../../assets/services/6.png";
import seven from "../../assets/services/7.png";
import { useTranslation } from "react-i18next";
import { HashLink } from "react-router-hash-link";

const MainServices = () => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  return (
    <div className="relative px-20 max-lg:px-5">
      <div className="text-center relative z-10">
        <h1 className="text-[#14294F] text-4xl max-lg:text-2xl font-bold mt-16 max-lg:mt-10 leading-relaxed w-3/5 max-lg:w-full mx-auto">
          {t("mainServices.exploreReliableHome")}
        </h1>
        <p className="text-[#737E91] text-2xl max-lg:text-lg mt-5 w-1/2 max-lg:w-full mx-auto">
          {t("mainServices.learnOurServices")}
        </p>

        <HashLink
          to="#bookService"
          className="mt-8 bg-white relative z-10 text-[#FE9B71] rounded-3xl border-2 border-[#FE9B71] w-[300px] max-lg:w-[230px] h-[55px] text-2xl max-lg:text-lg flex items-center justify-center font-semibold mx-auto"
        >
          {t("mainServices.bookServiceNow")}
        </HashLink>
      </div>
      <img src={one} className="w-[120px] max-lg:w-[80px] absolute left-0 top-5 max-lg:top-10 z-10" />
      <img src={two} className="w-[100px] max-lg:w-[70px] absolute left-96 max-lg:left-0 -top-8 z-0" />
      <img src={three} className="w-[150px] max-lg:w-[80px] absolute left-44 max-lg:left-14 top-28 z-10" />
      <img src={four} className="w-[120px] max-lg:w-[80px] absolute left-1/3 max-lg:left-10 top-48 z-0" />
      <img src={five} className="w-[120px] max-lg:w-[80px] absolute right-60 max-lg:right-0 top-0 z-0" />
      <img src={six} className="w-[120px] max-lg:w-[80px] absolute right-72 max-lg:right-0 top-44 z-0" />
      <img src={seven} className="w-[120px] max-lg:w-[80px] absolute right-0 top-20 z-10" />
    </div>
  );
};

export default MainServices;